class BaoProductFourSixty extends HTMLElement {
  connectedCallback () {
    // Create a new script element
    const script = document.createElement('script')

    // Get attributes from the custom element and set them on the script
    script.src = '//foursixty.com/media/scripts/fs.slider.v2.5.js'
    script.dataset.feedId = this.getAttribute('data-feed-id')
    script.dataset.theme = this.getAttribute('data-theme')
    script.dataset.connectorFilter = this.getAttribute('data-connector-filter')
    script.dataset.cellSize = this.getAttribute('data-cell-size')
    script.dataset.forUrl = this.getAttribute('data-for-url')

    this.appendChild(script)

    const scriptLoadCallback = () => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            if (this.itemCount > 1) {
              const section = document.getElementById(this.getAttribute('data-section-id'))

              if (this.itemCount > 3) {
                section.classList.add('fs-require-arrows')
              }

              this.printNumberOfItems()

              section.classList.remove('hidden')
            }
          }
        })
      })

      observer.observe(this, {
        childList: true,
        subtree: true,
      })
    }

    script.addEventListener('load', scriptLoadCallback)
  }

  printNumberOfItems () {
    this.style.setProperty('--Item_Count', this.itemCount)

    if (this.itemCount > 3) {
      this.style.setProperty('--Item_Count', 3)
    }
  }

  get itemCount () {
    return this.querySelectorAll('.fs-entry-container').length
  }
}

if (!customElements.get('bao-product-four-sixty')) {
  customElements.define('bao-product-four-sixty', BaoProductFourSixty)
}
